import { useState, useEffect, useRef } from 'react';
import { Button, Card, Form, Container, Col } from 'react-bootstrap';
import {FormHelper} from "../../../../Commons/Scripts/Utils";
import {AnimatedIconButton} from "../../../../Commons/Scripts/Componentes/AnimatedIconButton/AnimatedIconButton";
import '../../../../App/src/Assets/css/light-bootstrap-dashboard-pro-react.min.css'

export function ResetPasswoodPage({
  showLoading,
  hideLoading,
  setIsResetPassword,
  theme,
}){
  const [cardClasses, setCardClasses] = useState("card-hidden");
  const [form, setForm] = useState({
    Contrasena: "",
    ConfirmContrasena: "",
  });
  const urlParams = new URLSearchParams(window.location.search);
  const em = urlParams.get("em");
  const cc = urlParams.get("cc");

  useEffect(() => {
    if (em && cc) {
      setForm({ ...form, em: em, cc: cc });
    }
    return () => {
      cerrarAlertas();
    };
  }, []);

  const onInputChange = (e) => {
    FormHelper.handleChange(e, setForm);
  };

  const onSubmit = (e) => {
    showLoading();
    FormHelper.handleSubmit(e);
    cambioContrasena(form.Contrasena, form.ConfirmContrasena)
    setIsResetPassword(false);
  };
  const cardRef = useRef(null);
  useEffect(() => {
    if (cardRef.current) {
      cardRef.current.style.setProperty('min-width', '300px', 'important');
    }
    setTimeout(function () {
      setCardClasses("");
    }, 500);
  }, []);

  return (
    <>
      <div className="full-page section-image" data-color="black">
        <div className="content d-flex align-items-center p-0">
          <Container style={{ maxWidth: "65%", minWidth: "65%" }}>
            <Col className="mx-auto" xs="4">
              <Form className="form" onSubmit={onSubmit}>
                <Card
                  ref={cardRef}  
                  className={"card-login " + cardClasses}
                >
                  <Card.Header className="text-center" style={{
                    borderBottom: '1px solid #0000000d'
                  }}>
                    {theme.logo ? (
                      <img
                        alt="logo"
                        style={{objectFit: 'contain'}}
                        src={theme.logo}
                        height="80px"
                        width='275px'
                      />
                    ) : (
                      theme.appName
                    )}
                  </Card.Header>
                  <Card.Body
                    className="d-flex"
                    style={{
                      flexDirection: "column",
                      alignContent: "center",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Form.Group className='form-group'>
                      <label>Contraseña</label>
                      <Form.Control
                        required
                        autoComplete="new-password"
                        name="Contrasena"
                        type="password"
                        value={form.Contrasena}
                        onChange={onInputChange}
                      />
                    </Form.Group>
                    <Form.Group className='form-group'>
                      <label>Confirmar Contraseña</label>
                      <Form.Control
                        required
                        autoComplete="new-password"
                        name="ConfirmContrasena"
                        type="password"
                        value={form.ConfirmContrasena}
                        onChange={onInputChange}
                      />
                    </Form.Group>
                  </Card.Body>
                  <Card.Footer
                    className="d-flex"
                    style={{ justifyContent: "space-around" }}
                  >
                    <AnimatedIconButton
                      size="60px"
                      height="35px"
                      width="35px"
                      iconName="thumb"
                      message="Confirmar"
                      style={{ padding: "0px" }}
                      onClick={(e) => onSubmit(e)}
                      useVendorTheme={true}
                    />
                  </Card.Footer>
                </Card>
              </Form>
            </Col>
          </Container>
        </div>
      </div>
    </>
  );
};
